<div class="app-content" [inert]="showCriticalUpdate()">
  <router-outlet />

  @if (failedNavigationUrl()) {
    <main class="navigation-error">
      <div role="alert">
        <h1>{{ commonTranslations.failedToLoadData }}</h1>
      </div>
      <aw-button
        variant="tertiary"
        [text]="commonTranslations.retry"
        [disabled]="retryingNavigation()"
        (onclick)="retryNavigation()"
      />
    </main>
  }
</div>

<!-- Dynamic overlays must not inherit the app's scrolling layout or keyboard resize container. -->
<div class="overlay-root" [inert]="showCriticalUpdate()">
  <ng-container #overlayRoot />
  <div class="toast-stack">
    @for (entry of toastEntries(); track entry) {
      <aw-toast [entry]="entry" (dismissed)="dismissToast(entry)" />
    }
  </div>
</div>

@if (showCriticalUpdate()) {
  <aw-critical-update-screen />
}
